import { Helmet } from 'react-helmet-async';

/**
 * Centralized SEO + Open Graph metadata.
 * Used on landing, stories, events, activities for shareable cards.
 */
export default function Seo({
  title,
  description,
  image,
  type = 'website',
  url,
}) {
  const fullTitle = title ? `${title} — Zonta District 17 Area 1` : 'Zonta District 17 Area 1';
  const desc =
    description ||
    'Zonta District 17 Area 1 — empowering women through service and advocacy across our community.';
  const canonical = url || (typeof window !== 'undefined' ? window.location.href : undefined);
  // Fall back to the brand emblem so shared cards always carry the Zonta mark.
  const ogImage = image || '/logo/zonta_emblem_1024.png';

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {canonical && <link rel="canonical" href={canonical} />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      {canonical && <meta property="og:url" content={canonical} />}
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="Zonta District 17 Area 1" />

      {/* Twitter */}
      <meta name="twitter:card" content={image ? 'summary_large_image' : 'summary'} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
}
